import React from 'react';
import { motion } from 'framer-motion';
import { trackPixelEvent } from '../utils/metaPixel';
export const CHECKOUT_URL = 'https://english-biodecoding-kit.impultienda.ar/checkout/complet';
export const PRODUCT_NAME = 'BIODECODING PRACTITIONER KIT™';
export const PRICE = 'US$25';
export const PRICE_SHORT = 'US$25';
export const PRICE_FULL = 'US$50';
export const PRICE_VALUE = 25;
export const SUPPORT_EMAIL = 'soportelumencreativedigital@gmail.com';
export const INSTAGRAM_HANDLE = '@lumen_akasha';
export const INSTAGRAM_LINK = 'https://instagram.com/lumen_akasha';

/** Meta Pixel event fired when heading to checkout. */
export function trackCheckoutClick(): void {
  trackPixelEvent('InitiateCheckout', {
    content_name: PRODUCT_NAME,
    content_type: 'product',
    value: PRICE_VALUE,
    currency: 'USD'
  });
}
type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
};
export function Section({
  children,
  className = '',
  id = ''
}: SectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }} className={`relative mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 md:py-20 lg:px-8 ${className}`} data-id="element-293" data-mp="39k9dk6j3n1no">
      {children}
    </motion.section>;
}
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'blue' | 'gold';
};
export function CTAButton({
  children,
  href = '#comprar',
  className = '',
  fullWidth = false,
  variant = 'blue'
}: CTAButtonProps) {
  const colors = variant === 'gold' ? 'bg-amber-400 text-blue-950 hover:bg-amber-300' : 'bg-blue-900 text-white hover:bg-blue-950';
  return <motion.a href={href} onClick={() => {
    if (href === CHECKOUT_URL) trackCheckoutClick();
  }} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.14,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex items-center justify-center rounded-full px-8 py-4 text-lg font-bold shadow-lg transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-amber-400/50 ${colors} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-294" data-mp="27ux80yid5fos">
      {children}
    </motion.a>;
}